/* eslint-disable */
import React, { useEffect } from 'react';
import { t } from '@web-solutions/module-localization';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { PrimaryButton } from '../_shared/PrimaryButton';
import { heroImg } from '../_shared/hairstyle';
import styles from './style.module.scss';

function Page() {
  const { onNext, currentIndex } = useNav();
  const hero = heroImg();

  useEffect(() => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'view', { page: 'hairstyle-hero' });
  }, []);

  const start = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', { page: 'hairstyle-hero' });
    onNext();
  };

  return (
    <div className={styles.page}>
      <div className={styles.top}>
        <h1 className={styles.headline}>{t('hairstyleHero.title')}</h1>
        <p className={styles.sub}>{t('hairstyleHero.subtitle')}</p>
      </div>

      <div className={styles.art}>
        {hero ? <img src={hero} alt="" className={styles.artImg} /> : <div className={styles.artFace} />}
      </div>

      <div className={styles.footer}>
        <PrimaryButton sticky={false} onClick={start}>{t('hairstyleHero.cta')}</PrimaryButton>
      </div>
    </div>
  );
}

export default Page;
